import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Frame } from '@beef/legacy-ui-kit';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default function SmartFrame({ className, ...otherProps }) {
  return <Frame {...otherProps} className={cx('component', className)} />;
}

/**
 * Must be set for FrameSwitcher to accept Frame as it's own component
 */
SmartFrame.componentName = 'Frame';

SmartFrame.propTypes = {
  ...Frame.propTypes,
  className: PropTypes.string,
};
